<script setup>
defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
})
</script>
<template>
  <div class="img-text-cards p-bottom-xl-1 p-top-xl-1 row-130-25 max">
    <!-- eslint-disable vue/no-v-html -->
    <div v-if="block.titolo" class="title title-base" v-html="block.titolo" />
    <div class="blocks-container max-content">
      <div v-for="(card, index) in block.card" :key="index" class="block">
        <div class="left">
          <DefaultPicture
            :image="{ custom: card.immagine.responsiveImage }"
            :lazy-load="true"
            :alt="card.titolo"
          />
        </div>
        <div class="right">
          <div class="title title-base2" v-html="card.titolo" />
          <div class="text-s-1-b" v-html="card.testo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListImageText',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
